import {
  FETCH_COUNTRIES_BEGIN,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_FAILURE,
} from '../actions/countries';

export const initialState = {
  countries: [],
  error: null,
  isFetching: false,
};

const countries = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_COUNTRIES_BEGIN:
      return {
        ...state,
        error: null,
        isFetching: true,
      };
    case FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: null,
        isFetching: false,
      };
    case FETCH_COUNTRIES_FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };
    default:
      return state;
  }
};

export default countries;
